/*!
 * bem-cn v2.1.3
 * Friendly BEM class names generator, greate for React
 * @author Alexander Burtsev, https://github.com/albburtsev
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["block"] = factory();
	else
		root["block"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                   * How it's working?
	                                                                                                                                                                                                                                                   * The essential part of this module is based on using currying pattern.
	                                                                                                                                                                                                                                                   * Just take a look at the interface:
	                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                   * @example
	                                                                                                                                                                                                                                                  const selector = (settings, context) => {
	                                                                                                                                                                                                                                                  	const inner = () => {
	                                                                                                                                                                                                                                                  		return selector(...);
	                                                                                                                                                                                                                                                  	};
	                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                  	inner.toString = inner.valueOf = () => {
	                                                                                                                                                                                                                                                  		// ...
	                                                                                                                                                                                                                                                  	}
	                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                  	// ...
	                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                  	return inner;
	                                                                                                                                                                                                                                                  };
	                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                  const block = (name) => {
	                                                                                                                                                                                                                                                  	// ...
	                                                                                                                                                                                                                                                  
	                                                                                                                                                                                                                                                  	return selector(defaultSettings, {name});
	                                                                                                                                                                                                                                                  };
	                                                                                                                                                                                                                                                   */


	var _helpers = __webpack_require__(2);

	var _constants = __webpack_require__(1);

	var IS_PREFIX = 'is-';
	var HAS_PREFIX = 'has-';

	var defaultSettings = {
		ns: '',
		el: '__',
		mod: '_',
		modValue: '_',
		classMap: null
	},

	// Settings object is global on module level
	settings = (0, _helpers.assign)({}, defaultSettings);

	/**
	 * Returns given mixes as list of strings
	 * @param {*[]} mixes
	 * @return {String[]}
	 * @example
	block('block').mix(block('another')); "block another"
	block('one').mix(['two', 'three']); "one two three"
	 */
	function normilizeMixes() {
		var mixes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

		return mixes.map(function (mix) {
			if (typeof mix === 'function') {
				return mix.toString();
			} else if (Array.isArray(mix)) {
				return mix.join(' ');
			} else if (typeof mix === 'string') {
				return mix;
			}

			return '';
		}).filter(function (mix) {
			return mix;
		});
	}

	/**
	 * Returns final set of classes
	 * @return {String}
	 */
	function toString(settings, context) {
		var name = context.name;
		var mods = context.mods;
		var mixes = context.mixes;
		var states = context.states;
		var classes = [name];

		// Add list of modifiers
		if (mods) {
			classes = classes.concat(Object.keys(mods).filter(function (key) {
				return mods[key];
			}).map(function (key) {
				var value = mods[key];

				// Modifier with only name
				if (value === true) {
					return name + settings.mod + key;
					// Modifier with name and value
				} else {
						return name + settings.mod + key + settings.modValue + value;
					}
			}));
		}

		// Add states
		if (states) {
			Object.keys(states).forEach(function (prefix) {
				var statesByPrefix = states[prefix];

				classes = classes.concat(Object.keys(statesByPrefix).filter(function (key) {
					return statesByPrefix[key];
				}).map(function (key) {
					return prefix + key;
				}));
			});
		}

		// Add namespace
		if (settings.ns) {
			classes = classes.map(function (className) {
				return settings.ns + className;
			});
		}

		// Add mixes
		// Don't do it before adding namespace! @see https://github.com/albburtsev/bem-cn/issues/32
		if (mixes) {
			classes = classes.concat(normilizeMixes(mixes));
		}

		// Resolve class name from classMap
		if (settings.classMap) {
			classes = classes.map(function (className) {
				return settings.classMap[className] || className;
			});
		}

		return classes.join(' ');
	}

	/**
	 * Adds new mixes to context and returns selector
	 * @param {Object} settings
	 * @param {Object} context
	 * @param {*} mixes
	 * @return {Function}
	 */
	function mix(settings, context) {
		// Copy context object for new selector generator
		var copied = (0, _helpers.assign)({}, context);

		// Copy and update list of mixes

		for (var _len = arguments.length, mixes = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
			mixes[_key - 2] = arguments[_key];
		}

		copied.mixes = (copied.mixes || []).concat(mixes);

		return selector(settings, copied);
	}

	/**
	 * Adds new states to context and returns selector
	 * @param {Object} settings
	 * @param {Object} context
	 * @param {String} prefix One of available prefixes `is-` or `has-`
	 * @param {Object} states
	 * @return {Function}
	 */
	function state(settings, context, prefix) {
		// Copy context object for new selector generator
		var copied = (0, _helpers.assign)({}, context),
		    copiedState = (0, _helpers.assign)({}, copied.states || {});

		// Copy and update object with states

		for (var _len2 = arguments.length, states = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
			states[_key2 - 3] = arguments[_key2];
		}

		copiedState[prefix] = _helpers.assign.apply(undefined, [{}, copiedState[prefix] || {}].concat(states));
		copied.states = copiedState;

		return selector(settings, copied);
	}

	/**
	 * Selector generator, self-curried function
	 * @param {Object} settings
	 * @param {String} [settings.ns = ''] Namespace for all classes
	 * @param {String} [settings.el = '__'] Delimiter before element name
	 * @param {String} [settings.mod = '_'] Delimiter before modifier name
	 * @param {String} [settings.modValue = '_'] Delimiter before modifier value
	 * @param {Object} [settings.classMap = null]
	 * @param {Object} context
	 * @param {String} context.name Block or element name
	 * @param {Object} [context.mods] Store with all modifiers
	 * @param {Object} [context.states] Store with all states
	 * @param {Array} [context.mixes] List of external classes
	 * @return {Function}
	 */
	function selector(settings, context) {
		function inner() {
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}

			// Call without arguments, time to return class names as a string
			if (!args.length) {
				return toString(settings, context);
			}

			// Don't forget to copy context object for new selector generator
			var copied = (0, _helpers.assign)({}, context);

			// Add new elements and modifiers to the context
			copied = args.reduce(function (copied, arg) {
				// New element found
				if (typeof arg === 'string') {
					copied.name += settings.el + arg;
					// New modifier found
				} else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
						copied.mods = (0, _helpers.assign)(copied.mods || {}, arg);
					}

				return copied;
			}, copied);

			return selector(settings, copied);
		}

		inner.mix = mix.bind(null, settings, context);
		inner.has = state.bind(null, settings, context, HAS_PREFIX);
		inner.state = inner.is = state.bind(null, settings, context, IS_PREFIX);
		inner.toString = inner.valueOf = toString.bind(null, settings, context);
		inner.split = function () {
			for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				args[_key4] = arguments[_key4];
			}

			return String.prototype.split.apply(toString(settings, context), args);
		};

		return inner;
	}

	/**
	 * Creates new BEM block
	 * @param {String} name
	 * @return {Function} Selector generator
	 */
	function block(name) {
		if (typeof name !== 'string') {
			throw new Error(_constants.ERROR_BLOCK_NAME_TYPE);
		}

		name = (0, _helpers.trim)(name);

		if (!name) {
			throw new Error(_constants.ERROR_BLOCK_NAME_EMPTY);
		}

		// It is easy to define default settings here
		return selector(settings, { name: name });
	}

	/**
	 * Updates settings object
	 * @param  {Object} custom New custom settings
	 */
	block.setup = function () {
		var custom = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

		(0, _helpers.assign)(settings, custom);
	};

	/**
	 * Sets default settings
	 */
	block.reset = function () {
		(0, _helpers.assign)(settings, defaultSettings);
	};

	exports.default = block;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERROR_BLOCK_NAME_TYPE = exports.ERROR_BLOCK_NAME_TYPE = 'Block name should be a string';
	var ERROR_BLOCK_NAME_EMPTY = exports.ERROR_BLOCK_NAME_EMPTY = 'Block name should be non-empty';

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Removes whitespaces from ends of a string
	 * @param {String} string Source string
	 * @return {String}
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
	 */
	var trim = exports.trim = function trim(string) {
	  return string.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	};

	/**
	 * Copies all enumerable properties from given source objects to target
	 * @param {Object} [target]
	 * @param {Object} [source]
	 * @return {Object}
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 */
	var assign = exports.assign = function assign() {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }

	  var target = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	  for (var i = 0; i < args.length; i++) {
	    var source = args[i];
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ../~/bem-cn/dist/bem-cn.js
// module id = 611
// module chunks = 0